import { render, staticRenderFns } from "./AddChoose.vue?vue&type=template&id=3810e042&scoped=true&"
import script from "./AddChoose.vue?vue&type=script&lang=js&"
export * from "./AddChoose.vue?vue&type=script&lang=js&"
import style0 from "./AddChoose.vue?vue&type=style&index=0&id=3810e042&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3810e042",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3810e042')) {
      api.createRecord('3810e042', component.options)
    } else {
      api.reload('3810e042', component.options)
    }
    module.hot.accept("./AddChoose.vue?vue&type=template&id=3810e042&scoped=true&", function () {
      api.rerender('3810e042', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/familyMotto/comp/AddChoose.vue"
export default component.exports